export default "__VITE_ASSET__BHTT1Mkq__"